export const idCertificationRegex: RegExp = /^\d+$/;
export const emailRegex: RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,6}$/;
